import { MDText } from 'i18n-react';

import type { PhotoType } from 'Utilities/profiling/@types';

import { conditionSection, PhotoInput } from '../Photos/ImageUpload/photosSections';
import LocalTexts from '../VehicleProfilingTexts.json';

const LocalT = new MDText(LocalTexts);
export const LocalTCopy = (copy: string) => LocalT.translate(`confirmDetails.sections.${copy}`);

export const RESOLUTION = Object.freeze({
  DESKTOP: 'DESKTOP',
  MOBILE: 'MOBILE',
});

export const SINGLE_IMAGE_SIZE = {
  DESKTOP: {
    HEIGHT: 384,
    WIDTH: 512,
  },
  MOBILE: {
    HEIGHT: 324,
    WIDTH: 432,
  },
};

export const DAMAGES_IN_WIZARD = Object.freeze({
  damage_dents: 'hasDents',
  damage_electrical_mechanical: 'hasElectricsProblems',
  damage_missing_trims: 'hasMissingParts',
  damage_other: 'hasAdditionalDamage',
  damage_paintwork: 'hasPaintProblems',
  damage_scratches: 'hasScratches',
  damage_tyres: 'hasTyreProblems',
  damage_warning_lights: 'hasWarningLights',
  damage_wheels: 'hasDamagedWheels',
  damage_windscreen: 'hasWindscreenProblems',
});

export const DAMAGES_SIZES = Object.freeze({
  large: '(16cm +)',
  medium: '(6-15cm)',
  small: '(0-5cm)',
});

export const PHOTO_CATEGORY = Object.freeze({
  exterior: 'Exterior',
  interior: 'Interior',
  treads: 'Tyre treads',
  wheels: 'Wheels',
});

export const scrollToTopOfSection = (section: string) => {
  const elem = document.getElementById(section);
  if (elem) {
    const y = (elem.getBoundingClientRect().top + window.scrollY) - 24;
    window.scrollTo({
      behavior: 'auto',
      top: y,
    });
  }
};

export const getPresetImage = (presets?: PhotoType['presets'], presetName?: string) => {
  if (!presets?.length) {
    return null;
  }

  const preset = presets.find((p) => p.name === presetName);
  return preset?.url;
};

export const VEHICLE_DAMAGE_KIND_KEY = {
  DAMAGE_DENTS: 'damage_dents',
  DAMAGE_MECHANICAL_OR_ELECTRICAL: 'damage_electrical_mechanical',
  DAMAGE_MISSING_TRIMS: 'damage_missing_trims',
  DAMAGE_OTHER: 'damage_other',
  DAMAGE_PAINTWORK: 'damage_paintwork',
  DAMAGE_SCRATCHES: 'damage_scratches',
  DAMAGE_TYRE: 'damage_tyres',
  DAMAGE_WARNING_LIGHTS: 'damage_warning_lights',
  DAMAGE_WHEEL: 'damage_wheels',
  DAMAGE_WINDSCREEN: 'damage_windscreen',
} as const;

export const DAMAGE = {
  ELECTRICAL_MECHANICAL: {
    VALUE: VEHICLE_DAMAGE_KIND_KEY.DAMAGE_MECHANICAL_OR_ELECTRICAL,
  },
  OTHER_DAMAGE: {
    VALUE: VEHICLE_DAMAGE_KIND_KEY.DAMAGE_OTHER,
  },
  TYRES: {
    NAME: 'treads',
    VALUE: VEHICLE_DAMAGE_KIND_KEY.DAMAGE_TYRE,
  },
  WHEELS: {
    NAME: 'wheels',
    VALUE: VEHICLE_DAMAGE_KIND_KEY.DAMAGE_WHEEL,
  },
} as const;

export const CONDITION_GRID = Object.keys(conditionSection)
  .reduce<PhotoInput[]>((acc, x) => [...acc, ...conditionSection[x].inputs], []);
